type SpecificationListProps = {
  specifications: {
    specification: { name: string };
    value: string;
    sequence: number;
  }[];
  hidden?: boolean;
};

const SpecificationList = ({
  specifications,
  hidden = false,
}: SpecificationListProps) => (
  <dl hidden={hidden}>
    {specifications.map((spec) => (
      <div
        key={`spec-${spec.sequence}-${spec.specification.name}`}
        className="p-4 text-sm odd:bg-[#f7f7f7]"
      >
        <dt className="font-bold">{spec.specification.name}</dt>
        <dd>{spec.value}</dd>
      </div>
    ))}
  </dl>
);

export default SpecificationList;
